import {CareJourneyStep, CareJourneyDetailsResponse, ModuleType} from '@/api/dto/care-journey';
import {StepName, Title} from '@/components/pages/tasks/task_edit/progress/TaskEditStep.styles';
import DisplayHelpers from '@/helpers/display_helpers';
import WorkflowStepForm from '@/components/pages/tasks/task_edit/progress/WorkflowStepForm';

type Props = {
  careJourneyStep: CareJourneyStep;
  careJourneyDetails: CareJourneyDetailsResponse;
  fetching: boolean;
  disabled: boolean;
}

export default function WorkflowStep({ careJourneyStep, careJourneyDetails, disabled }: Props) {
  const stepLabel = careJourneyStep.displayLabel ?? DisplayHelpers.humanize(careJourneyStep.stepName);

  switch (careJourneyStep.moduleType) {
  case ModuleType.COMPLETE_FORM:
    return (
      <div>
        <StepName>
          <Title>{stepLabel}</Title>
        </StepName>
        <WorkflowStepForm
          careJourneyStep={careJourneyStep}
          careJourneyDetails={careJourneyDetails}
          disabled={disabled}
        />
      </div>
    );

  case ModuleType.SEND_MESSAGE:
    return (
      <div>
        <StepName>
          <Title>{stepLabel}</Title>
        </StepName>
        {/* TODO: render send message info - https://hbuco.atlassian.net/browse/CARECO-4437 */}
      </div>
    );

  default:
    return null;
  }
}
